const urlSafe = (str: string): string => str.replace(/[@,/:!$*+]/g, '_')

export default urlSafe
